'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Condition2 = require('../abstract/Condition');

var _Condition3 = _interopRequireDefault(_Condition2);

var _Predicate = require('../abstract/Predicate');

var _Predicate2 = _interopRequireDefault(_Predicate);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

var _ConditionsUtil = require('./ConditionsUtil');

var _ConditionsUtil2 = _interopRequireDefault(_ConditionsUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrCondition = function (_Condition) {
    (0, _inherits3.default)(OrCondition, _Condition);

    function OrCondition() {
        (0, _classCallCheck3.default)(this, OrCondition);
        return (0, _possibleConstructorReturn3.default)(this, (OrCondition.__proto__ || (0, _getPrototypeOf2.default)(OrCondition)).apply(this, arguments));
    }

    (0, _createClass3.default)(OrCondition, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            return _ConditionsUtil2.default.toOrQueryFragment(this.children);
        }
    }]);
    return OrCondition;
}(_Condition3.default);

OrCondition.accepts = [_Condition3.default, _Predicate2.default];
OrCondition.canHaveChildren = true;
OrCondition.terminalNode = false;
OrCondition.displayName = 'Or Condition';

_QueryNodeRegistry2.default.register(OrCondition);
exports.default = OrCondition;